// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-info[data-v-7bf4b1d4] .el-form-item__label {\n  font-size: 12px;\n}\n.el-col .el-icon-remove-outline[data-v-7bf4b1d4] {\n  margin-left: -30px;\n  color: #F56C6C;\n  font-size: 24px;\n}\n.el-col .el-icon-circle-plus-outline[data-v-7bf4b1d4] {\n  margin-left: -30px;\n  color: #409EFF;\n  font-size: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
